export enum KebabOption {
	ViewCustomResponses = 'view-custom-responses',
	ViewResponses = 'view-responses',
	PreviewForm = 'preview-form',
	EditForm = 'edit-form',
	Share = 'share',
	MarkAsComplete = 'mark-as-complete',
	Cancel = 'cancel',
	MarkAsActive = 'mark-as-active',
}

export interface IntakeCTA {
	label: string;
	leftIcon?: string;
	rightIcon?: string;
}
